import { EVENTBRITE_REFINEMENT_TO_CATEGORY } from '@eventbrite/categories';
import { gettext } from '@eventbrite/i18n';
import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import { logEvent } from '@eventbrite/statsig';
import React from 'react';
import {
    GA_SEARCH_CATEGORY,
    GA_VIEW_NEARBY_CITY_ACTION,
} from '../../../../constants/analytics';
import { useRouteContext } from '../../../../context';
import { RouteContextShape } from '../../../../context/route';
import { NearbyCities } from '../../../../shared/nearbyCities';
import { CategoryBrowseBucket } from '../../components/CategoryBrowseBucket';
import { CATEGORY_CONTENT_MAP } from '../../constants';
import { useLocation } from '../../hooks/queries/location';
import { useNearbyCities } from '../../hooks/queries/nearbyCities';
import './CategoryBrowseNearbyCities.scss';

const getActiveTagDisplayName = (routeInfo: Partial<RouteContextShape>) => {
    const activeCategory = routeInfo.match.params.category;
    const activeCategoryKey = EVENTBRITE_REFINEMENT_TO_CATEGORY[activeCategory];
    return CATEGORY_CONTENT_MAP[activeCategoryKey]?.title?.toLocaleLowerCase();
};

const _handleTrackClick = (newLocation?: string, currentLocation?: string) => {
    if (!newLocation || !currentLocation) {
        return;
    }

    trackAnalyticsEvent({
        category: GA_SEARCH_CATEGORY,
        action: GA_VIEW_NEARBY_CITY_ACTION,
        label: `${currentLocation}-${newLocation}`,
    });

    logEvent('CategoryBrowse - nearby_cities - Click - Nearby City');
};

export const CategoryBrowseNearbyCities: React.FunctionComponent = () => {
    const routeInfo = useRouteContext();
    const { data: location } = useLocation();

    const categoryBrowseNearbyCities = useNearbyCities();

    return (
        <CategoryBrowseBucket
            title={gettext(
                'Explore %(activeTagDisplayName)s events near %(place)s',
                {
                    activeTagDisplayName: getActiveTagDisplayName(routeInfo),
                    place: location?.currentPlace,
                },
            )}
            wrappingClasses={'category-browse-nearby-cities'}
        >
            <NearbyCities
                content={categoryBrowseNearbyCities}
                handleTrackClick={(newLocation: string) =>
                    _handleTrackClick(newLocation, location?.currentPlace)
                }
            ></NearbyCities>
        </CategoryBrowseBucket>
    );
};
